module.exports = __webpack_public_path__ + "static/media/team@2x.d90c8e31.jpg";